/* eslint-disable no-lone-blocks */
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { Label } from 'reactstrap';
import { updateEpikBox } from '../../../../../actions/EpikBoxes';
import ConfirmationModal from '../../../../ConfirmationModal';
import Toggle from '../../../../Toggle';
import EpikboxSip from '../BoxSipPri';
import EpikBoxPri from '../EpikboxPri/EpikboxPri';

export default function EpikBoxSipPir({ sipDetails }) {
  const dispatch = useDispatch();
  const [dcUpdatePopup, setDcUpdatePopup] = useState({ show: false, value: {} });
  const priSettings = useSelector(state => state.AppState.priSipData?.priSettingData);
  const sipSettings = useSelector(state => state.AppState.priSipData?.sipSettingData);

  const token = localStorage.getItem('jwtToken') || null;

  const [warningModal, setWarningModal] = useState(false);
  const box = useSelector(state => state.AppState.boxDetails.box);
  const [priSipStatus, setPriSipStatus] = useState({
    pri: box?.features?.pri,
    sip: box?.features?.sip,
  });

  const updateBox = async updatedFeature => {
    await dispatch(updateEpikBox(token, { ...box, features: updatedFeature }));
  };

  const updatePri = async () => {
    const updatedFeature = {
      ...box?.features,
      pri: !priSipStatus?.pri,
      sip: priSipStatus?.sip,
    };
    await updateBox(updatedFeature);
    setPriSipStatus({ ...priSipStatus, pri: !priSipStatus?.pri });
  };

  const onPriToggle = async () => {
    const divElement = document.getElementById('test-time-remaining');
    const isHidden = divElement.getAttribute('hidden') !== null;
    if (isHidden) {
      setDcUpdatePopup({ show: true });
    } else {
      if (priSipStatus?.pri) {
        if (priSettings?.numberSettings?.numbers?.length > 0) {
          toast.error('Please delete all numbers before disabling PRI');
        } else {
          await updatePri();
        }
      } else {
        await updatePri();
        setWarningModal(true);
      }
    }
  };
  const unLockBoxButton = async () => {
    const element = document.getElementById('test-lock-icon');
    if (element) {
      // Simulate a click event
      element.click();
    } else {
      console.error('Element with id "test-lock-icon" not found.');
    }
  };

  const updateSip = async () => {
    const updatedFeature = { ...box?.features, pri: priSipStatus?.pri, sip: !priSipStatus?.sip };
    await updateBox(updatedFeature);
    setPriSipStatus({ ...priSipStatus, sip: !priSipStatus?.sip });
  };

  const onSipToggle = async () => {
    const divElement = document.getElementById('test-time-remaining');
    const isHidden = divElement.getAttribute('hidden') !== null;
      if (isHidden) {
        setDcUpdatePopup({ show: true });
      } else {
      if (priSipStatus?.sip) {
        if (sipSettings?.numberSettings?.numbers?.length > 0) {
          toast.error('Please delete all numbers before disabling SIP');
        } else {
          await updateSip();
        }
      } else {
        await updateSip();
      }
    }
  };

  return (
    <>
      <div style={{ width: '100%', padding: '10px ' }}>
        <div style={{ display: 'flex', verticalAlign: 'center' }}>
          <Label>PRI</Label>
          <div style={{ paddingLeft: '20px', paddingRight: '20px' }}>
            <Toggle value={priSipStatus?.pri} onToggle={onPriToggle} />
          </div>
        </div>
        <div style={{ display: 'flex', verticalAlign: 'center' }}>
          <Label>SIP</Label>
          <div style={{ paddingLeft: '20px', paddingRight: '20px' }}>
            <Toggle value={priSipStatus?.sip} onToggle={onSipToggle} />
          </div>
        </div>
      </div>
      <div style={{ width: '100%', height: '238px', overflow: 'auto' }}>
        {priSipStatus?.pri && <EpikBoxPri priSipStatus={priSipStatus}  setDcUpdatePopup={setDcUpdatePopup} />}
        {priSipStatus?.sip && <EpikboxSip priSipStatus={priSipStatus} sipDetails={sipDetails}  setDcUpdatePopup={setDcUpdatePopup} />}
      </div>
      <ConfirmationModal
        bodyText="Please reboot this device for changes to take effect."
        isOpen={warningModal}
        onCancel={() => setWarningModal(false)}
        ignoreConfirmButton
        close
      />
       <ConfirmationModal
        bodyText={'You are attempting to make changes to a device that is not currently locked for editing. To prevent conflicting changes, please lock the device before proceeding.'}
        headerText={'Device Lock Required'}
        confirmBtnText={'Yes'}
        close={'No'}
        isOpen={dcUpdatePopup.show}
        onCancel={() => {
          setDcUpdatePopup({ show: false, value: {} });
        }}
        onConfirm={() => {
          unLockBoxButton();
          setDcUpdatePopup({ show: false, value: {} });
        }}
      />
    </>
  );
}
